export default __webpack_public_path__ + "static/media/about_us(1).31b83781.png";